import { createContext, useContext } from "react";
import { buildPermissionChecker } from "./permissionChecker";
import { SupportAdminWriteGuardProvider } from "./useSupportAdminWriteGuard";
import type { PermissionCheckerApi, PermissionProviderProps } from "./types";

const PermissionContext = createContext<PermissionCheckerApi | undefined>(
  undefined
);

export const PermissionProvider = (props: PermissionProviderProps) => {
  const { children, permissionList, role } = props;

  const permissionChecker = buildPermissionChecker(permissionList, role);

  return (
    <PermissionContext.Provider value={permissionChecker}>
      <SupportAdminWriteGuardProvider>
        {children}
      </SupportAdminWriteGuardProvider>
    </PermissionContext.Provider>
  );
};

export const usePermissionChecker = (): PermissionCheckerApi => {
  const permissionChecker = useContext(PermissionContext);
  if (!permissionChecker) {
    throw new Error(
      "usePermissionChecker must be used within a PermissionProvider"
    );
  }
  return permissionChecker;
};
